import styled from "@emotion/styled";

import {
  MDSButton,
  MDSButtonSize,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIcon,
  MDSIconKind,
} from "@/mds";
export const AgentOverlayEntryButtonView = ({
  isNarrow,
  label,
  accessibleLabel,
  onOpenConnectedWork,
}: {
  isNarrow: boolean;
  label: string;
  accessibleLabel: string;
  onOpenConnectedWork: () => void;
}) => (
  <StyledEntryButton
    $isNarrow={isNarrow}
    aria-label={accessibleLabel}
    size={MDSButtonSize.Small}
    variant={MDSButtonVariant.Transparent}
    onPress={onOpenConnectedWork}
  >
    <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.ChartNetwork} />
    {isNarrow ? null : label}
  </StyledEntryButton>
);

const StyledEntryButton = styled(MDSButton)<{ $isNarrow: boolean }>`
  background: ${({ theme }) => theme.colors.background.button.navigation.default};
  box-sizing: border-box;
  height: 100%;
  flex: 0 0 auto;
  min-width: ${({ $isNarrow }) => ($isNarrow ? "28px" : "auto")};
  padding-inline: ${({ theme }) => theme.spacing["2"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
  -webkit-app-region: no-drag;

  &[data-hovered]:not([data-disabled]) {
    background: ${({ theme }) => theme.colors.background.button.navigation.hover};
  }
`;
